export default "__VITE_ASSET__74c1a39c__"